import { Input, Table, Button, message, Modal } from 'antd'
import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { useSelector } from 'react-redux'
import OrderPaymentModal from '../orderPaymentModal.jsx'
import { http } from '@services/http.js'
import SuccessModal from '@Modal/SuccessModal/index.jsx'
import ErrorModal from '@Modal/ErrorModal/index.jsx'
import { config } from '../../../config'
import { fetchDepartments, fetchShippedSales } from '@utils/fetchData.js'
import { useQuery } from '@tanstack/react-query'
import {
	numberWithSpacesIntl,
	roundToTwoDecimals,
} from '@utils/numberWithSpaces.js'
import ViewIcon from '@assets/icons/viewSvg'
import { Tooltip, Spin } from 'antd'
import ViewSalesModal from '../ViewSalesModal'

const ShippedSalesInfo = ({
	data,
	onClose = () => {},
	ship = false,
	incoming = false,
	finishSale = false,
	refetch = () => {},
}) => {
	const { t } = useTranslation()

	const roleNames = useSelector((state) => state.main.roleNames)
	const employeeId = useSelector((state) => state.main.employeeId)
	const salesPersonCode = useSelector((state) => state.main.salesPersonCode)
	const { getMe } = useSelector((state) => state.main)

	const successRef = useRef()
	const errorRef = useRef()

	const [isModalVisible, setIsModalVisible] = useState(false)
	const [shipBtnLoading, setShipBtnLoading] = useState(false)
	const [finishSaleBtnLoading, setFinishSaleBtnLoading] = useState(false)
	const [dueDate, setDueDate] = useState('')
	const [deadLine, setDeadline] = useState('')
	const [itemDocLines, setItemDocLines] = useState(null)
	const [docEntry, setDocEntry] = useState('')
	const [selectedRowData, setSelectedRowData] = useState(null)
	const [isViewModalVisible, setIsViewModalVisible] = useState(false)
	const [totalQuantityItems, setTotalQuantityItems] = useState(0)

	useEffect(() => {
		if (data?.docEntry) {
			setDocEntry(data?.docEntry)
			console.log('data', data)
			const totalQuantity = data?.documentLines
				?.filter((item) => item.u_Produkt === null)
				.reduce((acc, item) => {
					return acc + +item.u_PlannedQuantity
				}, 0)
			console.log('totalQuantity', totalQuantity)
			setTotalQuantityItems(totalQuantity)
		}
	}, [data])

	const { data: departmentData = [] } = useQuery({
		queryKey: ['departments'],
		queryFn: fetchDepartments,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const {
		data: shippedData = [],
		isLoading,
		isPending,
	} = useQuery({
		queryKey: ['shippedSales', docEntry],
		queryFn: fetchShippedSales,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const finishSalePost = async () => {
		setFinishSaleBtnLoading(true)

		const documentLines = shippedData
			.map((line) => line.documentLines)
			.flat()
			.map((item, idx) => {
				return {
					baseEntry: item.docEntry,
					baseLine: item.lineNum,
					itemCode: item.itemCode,
					quantity: item.openQty,
					price: item.price,
					currency: item.currency,
					warehouseCode: item.warehouseCode || '',
					u_Coefficient: item.u_Coefficient,
					u_Height: item.u_Height,
					u_Width: item.u_Width,
					u_Kvmetr: item.u_Kvmetr,
				}
			})

		// const documentLinesItems = shippedData.documentLines
		// 	.filter(
		// 		(item) =>
		// 			roundToTwoDecimals(item.oneItemKvm * item.openQuantitySon) >
		// 			0,
		// 	)
		// 	.map((item, idx) => {
		// 		return {
		// 			baseEntry: data.docEntry,
		// 			baseLine: item.lineNum,
		// 			itemCode: item.itemCode,
		// 			quantity: roundToTwoDecimals(
		// 				item.oneItemKvm * item.openQuantitySon,
		// 			),
		// 			price: item.price,
		// 			currency: item.currency,
		// 			warehouseCode: item.warehouseCode || '',
		// 			u_Coefficient: item.u_Coefficient,
		// 			u_Height: item.u_Height,
		// 			u_Width: item.u_Width,
		// 			u_Kvmetr: item.openQuantitySon,
		// 		}
		// 	})

		const postingData = {
			cardCode: shippedData[0]?.cardCode,
			documentsOwner: employeeId,
			salesPersonCode: salesPersonCode,
			docCurrency: shippedData[0]?.docCurrency,
			department: shippedData[0]?.u_Department,
			documentLines: documentLines,
		}

		try {
			await http.post(
				`api/sales/sotuvga-nusxalash/${data?.docEntry}`,
				postingData,
			)
			onClose()
			refetch()
			successRef.current.open(t('sucCreated'))
		} catch (error) {
			errorRef.current.open(error?.response?.data?.message)
		} finally {
			setFinishSaleBtnLoading(false)
		}
	}

	const onView = (record) => {
		setSelectedRowData(record)
		setIsViewModalVisible(true)
	}

	if (!data) return null

	const columns = [
		{
			title: t('docNum'),
			dataIndex: 'docNumPrefix',
			key: 'docNumPrefix',
		},

		{
			title: t('date'),
			dataIndex: 'docDate',
			key: 'docDate',
			text: 'center',
			render: (text) => {
				const formattedText = moment(text).format('DD.MM.YYYY')
				return `${formattedText}`
			},
		},
		{
			title: t('mijoz'),
			dataIndex: 'cardName',
			key: 'cardName',
			text: 'center',
		},

		{
			title: t('shippedQuantity'),
			dataIndex: 'docTotalQuantity',
			key: 'docTotalQuantity',
			text: 'center',
			render: (text, record) => {
				const formattedText = numberWithSpacesIntl(
					roundToTwoDecimals(text),
				)
				return `${formattedText}`
			},
		},
		{
			title: t('salesManager'),
			dataIndex: 'slpName',
			key: 'slpName',
			text: 'center',
		},

		{
			title: t('status'),
			dataIndex: 'u_AbsoluteStatus',
			key: 'u_AbsoluteStatus',
			text: 'center',
		},
		{
			title: '',
			dataIndex: 'action',
			key: 'action',
			text: 'center',
			render: (text, record) => (
				<div className="flex gap-2 items-start justify-center">
					<div className="flex flex-col gap-2">
						<Tooltip title={t('infoSales')}>
							<button
								onClick={() => onView(record)}
								className="bg-[#2198c7] text-white w-[35px] h-[30px] rounded-lg flex justify-center items-center"
							>
								<ViewIcon />
							</button>
						</Tooltip>
						{/* <Tooltip title={t('NavigateOrders')}>
							<button
								onClick={() => {
									onNavigateOrder(record)
								}}
								className="bg-[#124153] text-white w-[35px] h-[30px] rounded-lg flex justify-center items-center"
							>
								<OrdersIcon />
							</button>
						</Tooltip> */}
					</div>
					{/* <div className="flex flex-col gap-2">
						<Tooltip title={t('NavigateMarshrut')}>
							<button
								onClick={() => {
									onNavigateCar(record)
								}}
								className="bg-[#26c92e] text-white w-[35px] h-[30px] rounded-lg flex justify-center items-center"
							>
								<CarIcon />
							</button>
						</Tooltip>
						<Tooltip title={t('printSeries')}>
							<button
								onClick={() => {
									onNavigateSeries(record)
								}}
								className="bg-yellow-600 text-white w-[35px] h-[30px] rounded-lg flex justify-center items-center"
							>
								<DocumentIcon />
							</button>
						</Tooltip>
					</div> */}
				</div>
			),
		},
	]

	return (
		<div className="w-full px-4 ">
			<div className="w-full">
				<div>
					{/* <p className="font-bold text-center">{t('items')}</p> */}
					<div className="flex items-center justify-end">
						<div className="flex flex-col items-start gap-2">
							<p className="font-bold">{t('totalQuantity')}</p>
							<Input
								className="w-[150px]"
								value={totalQuantityItems}
								disabled
							/>
						</div>
					</div>
					<Spin spinning={isLoading}>
						<Table
							columns={columns}
							dataSource={shippedData}
							pagination={false}
							loading={isLoading || isPending}
							className="border-1 mt-7  border-black"
							scroll={{ x: '100%' }}
							bordered
						/>
					</Spin>
				</div>

				<div className="w-full flex items-center justify-end mt-5  ">
					<div className="flex items-center gap-3">
						{incoming ? (
							<Button
								onClick={() => {
									setIsModalVisible(true)
								}}
								className="h-[30px] w-[140px]  bg-[#0A4D68] rounded-lg text-white "
							>
								{t('pay')}
							</Button>
						) : (
							''
						)}

						{finishSale ? (
							<Button
								onClick={finishSalePost}
								loading={finishSaleBtnLoading}
								className="h-[30px] w-auto  bg-[#0A4D68] rounded-lg text-white "
							>
								{t('finishSale')}
							</Button>
						) : (
							''
						)}
					</div>
				</div>
			</div>

			<ViewSalesModal
				visible={isViewModalVisible}
				data={selectedRowData}
				onClose={() => setIsViewModalVisible(false)}
				isShowShippedTab={false}
			/>

			<OrderPaymentModal
				visible={isModalVisible}
				data={data}
				onClose={() => setIsModalVisible(false)}
			/>
			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
		</div>
	)
}

export default ShippedSalesInfo
